module.exports = __webpack_public_path__ + "assets/images/caretaker_y.80111eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/caretaker_y.png
// module id = 687
// module chunks = 1